<div class="flex h-full flex-col">
  <app-access-limit-banner class="shrink-0" />
  <div class="min-h-0 flex-1" data-workspace>
    <app-split-view
      class="skin-frame"
      side="right"
      key="dp"
      [collapsedSize]="15"
      [magneticSize]="200"
      [iconTop]="38"
      [withIcon]="true"
      [singlePane]="companionPresentation.standalone()"
      [temporaryExpanded]="companionPresentation.replyTemplate() !== null"
      [temporaryCollapsed]="fullWindow.dpFolded()"
      [gutterSize]="companionPresentation.replyTemplate() !== null ? 6 : 8"
      (temporaryClosed)="companionPresentation.closeReply()"
      (temporaryOpened)="fullWindow.reopenDp()"
    >
      <div
        split-left-pane
        class="main"
        [style.padding-right.px]="companionPresentation.replyTemplate() !== null ? 6 : null"
        *spaceContext="'main'"
      >
        <router-outlet (activate)="routedLayoutActivated($event)" (deactivate)="routedLayoutDeactivated($event)" />
        <router-outlet name="settings" />
        <app-team-item-link-opener />
      </div>

      <div split-right-pane class="knowledge-panel" *spaceContext="'dp'">
        <app-dynamic-panel [nativePresentationHidden]="companionPresentation.replyTemplate() !== null" />
        @if (companionPresentation.replyTemplate(); as template) {
          <div class="absolute inset-0 flex min-h-0 flex-col">
            <ng-container [ngTemplateOutlet]="template" />
          </div>
        }
      </div>
    </app-split-view>
  </div>
</div>
